<div class="px-3">
  <table
    mat-table
    matSort
    matSortStart="desc"
    [dataSource]="dataSource"
    class="data-table table-fixed-head border-on-edge border-transparent dark-table w-100"
    id="data-table"
    aria-label="List of referrals"
  >
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center p-2" [colSpan]="displayedColumns.length">
        <span *ngIf="dataSource.data?.length === 0 && !filtersApplied"
          >No referrals are available for viewing.</span
        >
        <span *ngIf="dataSource.data?.length === 0 && filtersApplied"
          >No referrals match the applied filters.</span
        >
      </td>
    </tr>

    <!-- Urgency Column -->
    <ng-container matColumnDef="urgency">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Urgency"
        id="referral-list-column-urgency"
      >
        <div class="p-2 ml-2">Urgency</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2 ml-2">
          {{ getUrgencyText(row) }}
        </div>
      </td>
    </ng-container>

    <!-- Modality Column -->
    <ng-container matColumnDef="modality">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Modality"
        id="referral-list-column-modality"
      >
        <div class="p-2 ml-2">Modality</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2 ml-2">
          {{ row.modality }}
        </div>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Status"
        id="referral-list-column-status"
      >
        <div class="p-2">Status</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2">
          {{ getStatusText(row.status) }}
        </div>
      </td>
    </ng-container>

    <!-- Patient MRN Column -->
    <ng-container matColumnDef="mrn">
      <th mat-header-cell *matHeaderCellDef id="referral-list-column-mrn">
        <div class="p-2">MRN</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2">
          {{ row.patient?.patientExternalId }}
        </div>
      </td>
    </ng-container>

    <!-- Patient Name -->
    <ng-container matColumnDef="patientName">
      <th
        scope="col"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        id="referral-list-column-patientName"
      >
        <div class="p-2">Patient Name</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2 break-word">
          {{ displayPersonName(row.patient) }}
        </div>
      </td>
    </ng-container>

    <!-- Time of Referral Column -->
    <ng-container matColumnDef="timeOfReferral">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Time of Referral"
        id="referral-list-column-timeOfReferral"
      >
        <div class="p-2">Time of Referral</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2">
          {{ displayDateTime(row.processInitiatedAt) }}
        </div>
      </td>
    </ng-container>

    <!-- Time of Decision Column -->
    <ng-container matColumnDef="timeOfDecision">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        sortActionDescription="Sort by Time of Decision"
        id="referral-list-column-timeOfDecision"
        class="p-2"
      >
        Time of Decision
      </th>
      <td mat-cell *matCellDef="let row" class="p-2">
        {{ row.timeOfDecision ? displayDateTime(row.timeOfDecision) : '' }}
      </td>
    </ng-container>

    <!-- Org/Site Column -->
    <ng-container matColumnDef="referrer">
      <th mat-header-cell *matHeaderCellDef id="referral-list-column-referrer">
        <div class="p-2">Referring Clinician</div>
      </th>
      <td mat-cell *matCellDef="let row">
        <div class="p-2">
          {{ row.referrerName }}
        </div>
      </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action"
      ><th mat-header-cell *matHeaderCellDef id="referral-list-column-action">
        <div class="text-center p-2">Action Needed</div>
      </th>
      <td mat-cell *matCellDef="let row" class="text-center p-0">
        <div *ngIf="isReferralAcknowledgable(row.status)">
          <mat-icon
            class="small-icon ml-2"
            svgIcon="filled-warning-triangle"
          ></mat-icon>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="clickable"
      [ngClass]="getClass(row)"
      (click)="openDetails(row)"
    ></tr>
  </table>
  <div class="d-flex">
    <div *ngIf="showLoadMore" id="load-more-btn" class="mx-auto my-3">
      <button mat-stroked-button (click)="loadMore()">Load More</button>
    </div>
  </div>
  <mat-paginator
    [ngStyle]="{ display: 'none' }"
    [pageSize]="INITIAL_PAGE_SIZE"
  ></mat-paginator>
</div>
